import React, { useState, useEffect, useRef, useMemo } from "react";
import { Form, Modal, Button } from "react-bootstrap";
import axios from "axios";
import BASE_URL from "../../../assets/global/url";
import { useNavigate, Link } from "react-router-dom";
import swal from "sweetalert";
import {
  addDays,
  addWeeks,
  format,
  parse as parseDateFns,
  isValid as isValidDateFns,
} from "date-fns";
import DatePicker from "react-datepicker";
import useDecodeToken from "../../../hooks/customHook/useDecodeToken";
import Select from "react-select";
import CustomerSelect from "../../../components/inputs/CustomerSelect";
import { selectCustomStyles } from "../../../assets/global/selectCustomStyles";
import useDarkMode from "../../../components/Themes/Usedarkmode";
import {
  currencyList,
  formatToTwoDecimal,
  getCurrencySymbol,
  parseNumber,
} from "../../../utils/numberFormatter";
import { checkDrNumber } from "../../../services/DrSalesValidator";
import NumberInDecimals from "../../../components/inputs/NumberFormatted";
import { warnIfNoCutoff } from "../../../utils/cutoffDateValidation";
import TypedDateInput, {
  DATE_INPUT_FORMAT,
  DATE_DISPLAY_FORMAT,
  DATE_PICKER_FORMATS,
} from "../../../components/inputs/TypedDateInput";

// Typed date input (Invoice Date / Due Date) must follow MM/dd/yyyy (e.g. 10/08/2026).
// Same rules as the Select Claim Date modal in collection.jsx: slashes are added
// automatically; anything that is not a valid prefix of that format (letters,
// extra digits, other date formats) is rejected and the input keeps its previous
// text. Returns the masked text, or null when the keystroke was rejected.
const maskTypedDate = (e) => {
  const raw = e?.target?.value;
  if (typeof raw !== "string") return null;

  const next = raw
    .replace(/^(\d{2})(\d)/, "$1/$2")
    .replace(/^(\d{2}\/\d{2})(\d)/, "$1/$2");

  // Changed to \d{0,4} to allow 4 digit years
  if (!/^(\d{0,2}|\d{2}\/\d{0,2}|\d{2}\/\d{2}\/\d{0,4})$/.test(next)) {
    e.preventDefault();
    return null;
  }
  e.target.value = next;
  return next;
};

const Create_invoice = () => {
  const { themeSelectStyles } = useDarkMode();
  const drInputRef = useRef(null);

  const getManilaDate = () => {
    const now = new Date();
    const manilaTime = new Intl.DateTimeFormat("en-CA", {
      timeZone: "Asia/Manila",
      year: "numeric",
      month: "2-digit",
      day: "2-digit",
    }).format(now);
    return manilaTime;
  };

  const userLoggedID = useDecodeToken();
  const navigate = useNavigate();
  const [validated, setValidated] = useState(false);
  const [isSaving, setIsSaving] = useState(false);
  const [customerData, setCustomerData] = useState([]);
  const [currencyData, setCurrencyData] = useState([]);
  const [productData, setProductData] = useState([]);
  const [cutOffData, setCutOffData] = useState([]);
  const [warehouseData, setWarehouseData] = useState([]);
  const [subject3Data, setSubject3Data] = useState([]);
  const [selectedInvoiceDate, setSelectedInvoiceDate] =
    useState(getManilaDate());

  const [transactionDiscountModal, setTransactionDiscountModal] =
    useState(false);
  const [shippingFeeModal, setShippingFeeModal] = useState(false);
  const [displayDiscount, setDisplayDiscount] = useState(0);
  const [displayShippingFee, setDisplayShippingFee] = useState(0);
  const [inputDiscount, setInputDiscount] = useState("");
  const [inputShippingFee, setInputShippingFee] = useState("");
  const [modalDiscount, setModalDiscount] = useState(true);
  const [modalDiscountType, setModalDiscountType] = useState("fixed");
  const [modalDiscountValue, setModalDiscountValue] = useState("");
  const [weighingFeeModal, setWeighingFeeModal] = useState(false);
  const [otherFeeModal, setOtherFeeModal] = useState(false);
  const [displayWeighingFee, setDisplayWeighingFee] = useState(0);
  const [displayOtherFee, setDisplayOtherFee] = useState(0);
  const [inputWeighingFee, setInputWeighingFee] = useState("");
  const [inputOtherFee, setInputOtherFee] = useState("");
  const [otherFees, setOtherFees] = useState([]);
  const [totalFees, setTotalFees] = useState(0);
  const OTHER_FEE_PAGE_SIZE = 5;
  const [otherFeePage, setOtherFeePage] = useState(0);

  const handleCloseTransactionDiscount = () =>
    setTransactionDiscountModal(false);
  const handleCloseShippingFee = () => setShippingFeeModal(false);
  const handleCloseWeighingFee = () => setWeighingFeeModal(false);
  const handleCloseOtherFee = () => setOtherFeeModal(false);

  const [editIndex, setEditIndex] = useState(null);

  const [transactionId, setTransactionId] = useState("");
  const [clientTransactionId, setClientTransactionId] = useState("");
  const [selectedWarehouse, setSelectedWarehouse] = useState("");
  const [selectedCustomer, setSelectedCustomer] = useState("");
  const [selectedMethod, setSelectedMethod] = useState("");
  const [selectedDueDate, setSelectedDueDate] = useState("");
  const [dueDateError, setDueDateError] = useState("");
  const [inputPaymentTerms, setInputPaymentTerms] = useState("");
  //Fix auto select destination and currency based on selected customer
  //If no customer selected it will be default value
  const [selectedDestination, setSelectedDestination] = useState("");
  const [selectedCurrency, setSelectedCurrency] = useState("");
  const [selectedSubject3, setSelectedSubject3] = useState("");
  const [remarks, setRemarks] = useState("");
  const [drNumberEnabled, setDrNumberEnabled] = useState(false);
  const [drNumber, setDrNumber] = useState("");
  const [poNumber, setPoNumber] = useState("");
  const [containerNumber, setContainerNumber] = useState("");
  const [pier, setPier] = useState("");
  const [currencyRate, setCurrencyRate] = useState(1);
  const [shipmentFee, setShipmentFee] = useState("");
  const [preVatBase, setPreVatBase] = useState(0);
  const [vatPercent, setVatPercent] = useState(0);
  const [taxSettings, setTaxSettings] = useState([]);
  const [selectedTaxId, setSelectedTaxId] = useState("");
  const [selectedTaxRate, setSelectedTaxRate] = useState(0);
  const [isSpecialTax, setIsSpecialTax] = useState(false);
  const [backupVatPercent, setBackupVatPercent] = useState("");
  const [backupTaxId, setBackupTaxId] = useState("");
  const [backupTaxRate, setBackupTaxRate] = useState(0);
  const [unitPriceInputs, setUnitPriceInputs] = useState({}); // keyed by index, holds raw typing value

  // For item list default value
  const defaultItem = {
    productCode: "",
    productName: "",
    remaining: "",
    averagePrice: "",
    original_php_price: 0, // Raw PHP base price kept for re-conversion when currency changes
    quantity: "",
    moisture: "",
    netWeight: "",
    unitPrice: "",
    sales_profit: "",
    discount: "",
    subtotal: 0,
    discountType: "percentage",
  };

  // Initialize state with 5 default items
  const [items, setItems] = useState(
    Array.from({ length: 5 }, () => ({ ...defaultItem })),
  );

  const [totalItemDiscount, setTotalItemDiscount] = useState(0);
  const [totalAmount, setTotalAmount] = useState(0);
  const [totalQuantity, setTotalQuantity] = useState(0);
  const [totalMoisture, setTotalMoisture] = useState(0);
  const [totalNetWeight, setTotalNetWeight] = useState(0);
  const [totalWeightedAmount, setTotalWeightedAmount] = useState(0);
  const [totalMoistureAmount, setTotalMoistureAmount] = useState(0);
  const [totalNetWeightAmount, setTotalNetWeightAmount] = useState(0);
  const [amount, setAmount] = useState(0);
  const [qty, setQty] = useState(0);
  const [isAmountQtyDisabled, setIsAmountQtyDisabled] = useState(true);
  const discountAmountPhp = useRef(0);
  const totalAmountUseRef = useRef(0);
  const currencySymbol = getCurrencySymbol(currencyData, selectedCurrency);

  const handleShowTransactionDiscount = () => {
    if ((parseFloat(totalAmountUseRef.current) || 0) <= 0) {
      swal({
        icon: "error",
        title: "No Products Added",
        text: "Please add at least one product with a valid quantity before adding a discount.",
      });
      return;
    }
    setTransactionDiscountModal(true);
  };

  const handleShowWeighingFee = () => {
    if ((parseFloat(totalAmountUseRef.current) || 0) <= 0) {
      swal({
        icon: "error",
        title: "No Products Added",
        text: "Please add at least one product with a valid quantity before adding a weighing fee.",
      });
      return;
    }
    setWeighingFeeModal(true);
  };

  const handleShowOtherFee = () => {
    if ((parseFloat(totalAmountUseRef.current) || 0) <= 0) {
      swal({
        icon: "error",
        title: "No Products Added",
        text: "Please add at least one product with a valid quantity before adding other fees.",
      });
      return;
    }
    setOtherFeeModal(true);
  };

  const addNewFee = () => {
    const newFees = [...otherFees, { feeName: "", feeAmount: "" }];
    setOtherFees(newFees);
    setOtherFeePage(Math.floor((newFees.length - 1) / OTHER_FEE_PAGE_SIZE));
  };

  const handleFeeChange = (index, field, value) => {
    const newOtherFees = otherFees.map((fee, i) =>
      i === index ? { ...fee, [field]: value } : fee,
    );
    setOtherFees(newOtherFees);
  };

  const removeFee = (index) => {
    const newOtherFees = otherFees.filter((_, i) => i !== index);
    setOtherFees(newOtherFees);
    const newTotalPages = Math.ceil(newOtherFees.length / OTHER_FEE_PAGE_SIZE);
    if (otherFeePage >= newTotalPages && otherFeePage > 0) {
      setOtherFeePage((p) => p - 1);
    }
  };

  const handleWeighingFeeChange = (value) => {
    setInputWeighingFee(value);
    const fee = parseNumber(value) || 0;
    setDisplayWeighingFee(fee);

    calculateTotals(
      items,
      vatPercent,
      selectedTaxRate,
      fee,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
      isSpecialTax,
    );
  };

  const handleAddWeighingFee = () => {
    const fee = parseFloat(inputWeighingFee.replace(/,/g, "")) || 0;
    setDisplayWeighingFee(fee);
    calculateTotals(
      items,
      vatPercent,
      selectedTaxRate,
      fee,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
    );
    setWeighingFeeModal(false);
  };

  const handleRemoveWeighingFee = (e) => {
    e.stopPropagation();
    setDisplayWeighingFee(0);
    setInputWeighingFee("");
    calculateTotals(
      items,
      vatPercent,
      selectedTaxRate,
      0,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
    );
  };

  const handleOtherFeeChange = (value) => {
    setInputOtherFee(value);
    const fee = parseNumber(value) || 0;
    setDisplayOtherFee(fee);

    calculateTotals(
      items,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      fee,
      otherFees,
      displayDiscount,
      modalDiscountType,
      isSpecialTax,
    );
  };

  const handleAddOtherFee = () => {
    const fee = parseFloat(inputOtherFee.replace(/,/g, "")) || 0;
    setDisplayOtherFee(fee);
    calculateTotals(
      items,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      fee,
      otherFees,
      displayDiscount,
      modalDiscountType,
    );
    setOtherFeeModal(false);
  };

  const handleRemoveOtherFee = (e) => {
    e.stopPropagation();
    setDisplayOtherFee(0);
    setInputOtherFee("");
    calculateTotals(
      items,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      0,
      otherFees,
      displayDiscount,
      modalDiscountType,
    );
  };

  const fetchTransactionCode = () => {
    axios
      .get(BASE_URL + "/invoice/transactionSalesId")
      .then((res) => {
        setTransactionId(res.data);
      })
      .catch((err) => {
        console.log(err);
      });

    // Display-only SI-YY-MM-0001 preview; the server assigns the real code
    // on save.
    axios
      .get(BASE_URL + "/invoice/getClientCodePreview")
      .then((res) => {
        const { prefix, nextSeq } = res.data;
        setClientTransactionId(`${prefix}${String(nextSeq).padStart(4, "0")}`);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchDrNumberCode = async () => {
    try {
      const res = await axios.get(BASE_URL + "/invoice/getDrNumberCode");
      setDrNumber(res.data);
    } catch (err) {
      console.error("Error fetching DR Number:", err);
      swal({
        icon: "error",
        title: "Error",
        text: "Failed to generate DR Number.",
      });
    }
  };

  const fetchCutOff = () => {
    axios
      .get(BASE_URL + "/invoice/getCutoffPosted")
      .then((res) => {
        setCutOffData(res.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchWarehouse = () => {
    axios
      .get(BASE_URL + "/invoice/getWarehouse")
      .then((res) => {
        setWarehouseData(res.data);

        // Auto Select the warehouse
        const mainWarehouse = res.data.find((w) =>
          w.name.toLowerCase().includes("main valenzuela"),
        );
        if (mainWarehouse) {
          setSelectedWarehouse(mainWarehouse.warehouse_id);
          fetchDataProduct(mainWarehouse.warehouse_id);
        }
      })
      .catch((err) => console.log(err));
  };

  const fetchDataProduct = async (warehouse_id) => {
    try {
      if (!warehouse_id) {
        setProductData([]);
        return;
      }

      const [productRes] = await Promise.all([
        axios.get(
          `${BASE_URL}/invoice/getProductInventoryInvoice?warehouse_id=${warehouse_id}`,
        ),
      ]);

      setProductData(productRes.data);
      //For checking the flow in console log
      console.log("PRODUCT DATA: " + JSON.stringify(productRes, null, 2));
    } catch (error) {
      console.error(error);
    }
  };

  const fetchCustomerCurrency = async () => {
    try {
      const [currencyRes, customerRes] = await Promise.all([
        axios.get(`${BASE_URL}/currency/fetchCurrency`),
        axios.get(`${BASE_URL}/invoice/getCustomersData`),
      ]);

      setCurrencyData(currencyRes.data);

      const sortedCustomerList = customerRes.data.sort(
        (a, b) => b.customer_id - a.customer_id,
      );
      setCustomerData(sortedCustomerList);
    } catch (error) {
      console.error(error);
    }
  };

  const fetchLiabilitySub3 = () => {
    axios
      .get(BASE_URL + "/invoice/getSubject3", {
        params: {
          selectedCurrency,
        },
      })
      .then((res) => {
        setSubject3Data(res.data);
      })
      .catch((err) => {
        console.error("Error fetching data:", err);
      });
  };

  const fetchActiveSalesTaxes = async () => {
    try {
      const res = await axios.get(`${BASE_URL}/invoice/getActiveSalesTax`);
      setTaxSettings(res.data);
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchDataProduct();
    fetchTransactionCode();
    fetchCutOff();
    fetchWarehouse();
    fetchCustomerCurrency();
    fetchActiveSalesTaxes();
  }, []);

  console.log(taxSettings);

  useEffect(() => {
    const total = otherFees.reduce(
      (sum, fee) => sum + (parseFloat(fee.feeAmount) || 0),
      0,
    );
    setTotalFees(total);
    calculateTotals(
      items,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
      isSpecialTax,
    );
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [otherFees]);

  useEffect(() => {
    if (selectedCurrency) {
      fetchLiabilitySub3();
    }
  }, [selectedCurrency]);

  const addNewItem = () => {
    setItems([
      ...items,
      {
        productCode: "",
        productName: "",
        remaining: "",
        averagePrice: "",
        original_php_price: 0,
        quantity: "",
        moisture: "",
        netWeight: "",
        unitPrice: "",
        sales_profit: "",
        discount: "",
        subtotal: 0,
        discountType: "percentage",
      },
    ]);
  };

  // const handleProductChange = (index, productId) => {
  //   const selectedProduct = productData.find(
  //     (product) => product.product_id === parseInt(productId)
  //   );
  //   const updatedItems = [...items];
  //   if (selectedProduct) {
  //     updatedItems[index].productCode = selectedProduct.product_code;
  //     updatedItems[index].remaining = selectedProduct.stock;
  //     updatedItems[index].averagePrice = selectedProduct.average_price;
  //     updatedItems[index].productName = productId;
  //   }
  //   setItems(updatedItems);
  // };

  // Unit Price shown when a product is picked: 2 decimals unless the 3rd or 4th
  // decimal has a value, then all 4.
  // 80 -> 80.00, 80.5 -> 80.50, 80.0001 -> 80.0001, 80.123 -> 80.1230, 0 -> 0.00
  const formatUnitPriceDisplay = (value) => {
    const fixed = Number(value).toFixed(4);
    if (!Number.isFinite(Number(fixed)) || Number(fixed) === 0) return "0.0000";

    return fixed.endsWith("00") ? fixed.slice(0, -2) : fixed;
  };

  const handleProductChange = (index, selectedOption) => {
    const selectedProduct = productData.find(
      (product) => String(product.product_id) === String(selectedOption?.value),
    );

    const updatedItems = [...items];
    if (selectedProduct) {
      // ── Currency Conversion ─────────────────────────────────────────────
      // average_price is always stored in PHP.
      // Divide by the current currency rate to convert to the selected currency.
      // e.g. PHP 100 ÷ rate 60 = USD 1.67
      const rawPhpPrice = selectedProduct.average_price || 0;
      const currentRate =
        parseFloat(String(currencyRate).replace(/,/g, "")) || 1;
      const convertedPrice = formatUnitPriceDisplay(rawPhpPrice / currentRate);
      // ────────────────────────────────────────────────────────────────────

      updatedItems[index] = {
        ...updatedItems[index],
        productCode: selectedProduct.product_code,
        remaining: selectedProduct.total_stock,
        averagePrice: convertedPrice, // converted — used for price indicator
        original_php_price: rawPhpPrice, // stored PHP base for future re-conversion
        // Added unitPrice (converted)
        unitPrice: convertedPrice,
        productName: selectedOption,
        stockDetails: selectedProduct.stock_details,
        moisture: 0,
      };
    }
    setItems(updatedItems);

    if (selectedProduct.total_stock === 0) {
      swal({
        icon: "warning",
        title: "Out of Stock",
        text: "The remaining quantity of this product is zero.",
      });
    }
  };

  // const getFilteredProductData = (index) => {
  //   const selectedProductIds = items
  //     .map((item) => item.productName?.value)
  //     .filter((id) => id);
  //   return productData.filter(
  //     (product) =>
  //       !selectedProductIds.includes(product.product_id.toString()) ||
  //       items[index].productName === product.product_id.toString()
  //   );
  // };

  const getFilteredProductData = (index) => {
    return productData;
  };

  const removeComma = (n) => {
    return parseFloat(String(n).replace(/,/g, ""));
  };

  console.log(items);

  const shipmentAmount = (value, field) => {
    const newNumericValue = parseNumber(value) || 0;

    if (field === "amount") {
      setAmount(value);

      const currentQty = parseNumber(qty) || 0;
      setShipmentFee(newNumericValue * currentQty);
    } else if (field === "qty") {
      setQty(value);

      const currentAmount = parseNumber(amount) || 0;
      setShipmentFee(newNumericValue * currentAmount);
    }
  };

  const handleCurrencyRateChange = (e) => {
    let inputValue = e.target.value.replace(/[^0-9.]/g, "");
    if ((inputValue.match(/\./g) || []).length > 1) return;
    let [integerPart, decimalPart] = inputValue.split(".");
    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    setCurrencyRate(formattedValue);
  };

  const handleTransactionDiscount = (e) => {
    let inputValue = e.target.value.replace(/[^0-9.,]/g, "");

    if ((inputValue.match(/\./g) || []).length > 1) {
      return;
    }

    let [integerPart, decimalPart] = inputValue.split(".");

    if (integerPart) {
      integerPart = integerPart.replace(/,/g, "");
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;
    setInputDiscount(formattedValue);
  };

  // const handleInputQTY = (index, field, value) => {
  //   if (value === ".") {
  //     setItems((prevItems) => {
  //       const updatedItems = [...prevItems];
  //       updatedItems[index][field] += ".";
  //       return updatedItems;
  //     });
  //     return;
  //   }

  //   let inputValue = value.replace(/[^0-9.]/g, "");

  //   if ((inputValue.match(/\./g) || []).length > 1) return;

  //   let [integerPart, decimalPart] = inputValue.split(".");

  //   if (integerPart) {
  //     integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  //   }

  //   let formattedValue =
  //     decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

  //   // Remove commas for calculations
  //   let numericValue = parseFloat(inputValue.replace(/,/g, "")) || 0;

  //   const updatedItems = [...items];
  //   updatedItems[index][field] = formattedValue; // Store formatted value in the state

  //   const quantity =
  //     parseFloat(String(updatedItems[index].quantity).replace(/,/g, "")) || 0;
  //   const unitPrice =
  //     parseFloat(String(updatedItems[index].unitPrice).replace(/,/g, "")) || 0;
  //   let discount =
  //     parseFloat(String(updatedItems[index].discount).replace(/,/g, "")) || 0;

  //   if (field === "unitPrice" || field === "averagePrice") {
  //     const averagePrices =
  //       parseFloat(
  //         String(updatedItems[index].averagePrice).replace(/,/g, "")
  //       ) || 0;
  //     updatedItems[index].sales_profit = averagePrices - unitPrice;
  //   }

  //   let subtotal = quantity * unitPrice;

  //   if (updatedItems[index].discountType === "percentage") {
  //     discount = (discount / 100) * subtotal;
  //   }

  //   if (!isNaN(discount)) {
  //     if (discount > subtotal) {
  //       swal({
  //         icon: "error",
  //         title: "Invalid Discount",
  //         text: "The discount should not exceed the total of the subtotal.",
  //       });
  //       updatedItems[index].discount = "0";
  //       discount = 0;
  //     }
  //     subtotal -= discount;
  //   }

  //   updatedItems[index].subtotal = subtotal;

  //   if (field === "quantity") {
  //     const quantity = numericValue;
  //     const remaining =
  //       parseFloat(String(updatedItems[index].remaining).replace(/,/g, "")) ||
  //       0;

  //     if (quantity > remaining) {
  //       swal({
  //         icon: "error",
  //         title: "Invalid Quantity",
  //         text: `The qty inputted must not exceed the available stock (${remaining}).`,
  //       });
  //       updatedItems[index].quantity = "0";
  //     }
  //   }

  //   setItems(updatedItems);
  //   calculateTotals(updatedItems);
  // };

  const handleInputQTY = (index, field, value) => {
    // if (value === ".") {
    //   setItems((prevItems) => {
    //     const updatedItems = [...prevItems];
    //     updatedItems[index][field] += ".";
    //     return updatedItems;
    //   });
    //   return;
    // }

    let inputValue = value.replace(/[^0-9.]/g, "");

    if ((inputValue.match(/\./g) || []).length > 1) return;

    let [integerPart, decimalPart] = inputValue.split(".");

    if (integerPart) {
      integerPart = integerPart.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }

    let formattedValue =
      decimalPart !== undefined ? `${integerPart}.${decimalPart}` : integerPart;

    const cleanedValue = formattedValue.replace(/^0+,|^0+/, ""); // Remove leading zeros and comma

    // Remove commas for calculations
    let numericValue = parseFloat(inputValue.replace(/,/g, "")) || 0;

    const updatedItems = [...items];
    updatedItems[index][field] =
      value.length > 1 && !value.includes(".") ? cleanedValue : formattedValue;

    const quantity =
      parseFloat(String(updatedItems[index].quantity).replace(/,/g, "")) || 0;
    let moisture =
      parseFloat(String(updatedItems[index].moisture).replace(/,/g, "")) || 0;
    const unitPrice =
      parseFloat(String(updatedItems[index].unitPrice).replace(/,/g, "")) || 0;
    let discount =
      parseFloat(String(updatedItems[index].discount).replace(/,/g, "")) || 0;
    let netWeight =
      parseFloat(String(updatedItems[index].netWeight).replace(/,/g, "")) || 0;

    if (field === "moisture") {
      // Validation for not exceeding 100%
      if (
        parseFloat(String(updatedItems[index].moisture).replace(/,/g, "")) > 100
      ) {
        swal({
          icon: "error",
          title: "Invalid Moisture",
          text: "Moisture cannot exceed 100%.",
        });
        updatedItems[index].moisture = "0";
        moisture = 0;
      }
    }

    // pag ang netWeight hindi directly edited, process ang tamang calculation
    if (field !== "netWeight") {
      // netWeight = quantity * (1 - moisture / 100);
      netWeight = Math.round(quantity * (1 - moisture / 100));

      if (!isFinite(netWeight) || isNaN(netWeight)) {
        netWeight = 0;
      }

      const [integer, decimal] = String(netWeight).split(".");

      updatedItems[index].netWeight =
        integer.replace(/\B(?=(\d{3})+(?!\d))/g, ",") +
        (decimal ? "." + decimal : "");
    } else if (field === "netWeight") {
      // moisture = 100 * (1 - netWeight / quantity).toFixed(2);
      moisture = parseFloat((100 * (1 - netWeight / quantity)).toFixed(2));

      if (!isFinite(moisture) || isNaN(moisture)) {
        moisture = 0;
      }
      updatedItems[index].moisture = moisture;
    }
    // Optional condition back-calculate moisture from netWeight and quantity kapag directly nag-edit ang netWeight
    // else if (field === "netWeight" && quantity > 0) {

    //   // moisture = (1 - (netWeight / quantity)) * 100;
    //   // updatedItems[index].moisture = moisture;
    // }

    // Allow zero unit price - calculate subtotal normally
    let subtotal = netWeight * unitPrice; // This will be 0 if unitPrice is 0, which is now allowed

    // Old Unit Price Calculation
    // if (field === "unitPrice" || field === "averagePrice") {
    //   const averagePrices =
    //     parseFloat(
    //       String(updatedItems[index].averagePrice).replace(/,/g, ""),
    //     ) || 0;
    //   updatedItems[index].sales_profit = averagePrices - unitPrice;
    // }

    if (field === "unitPrice" || field === "averagePrice") {
      const averagePrices =
        parseFloat(
          String(updatedItems[index].averagePrice).replace(/,/g, ""),
        ) || 0;

      // Recalculate sales profit: Average Price - Unit Price
      updatedItems[index].sales_profit = unitPrice - averagePrices;
    }

    if (field === "discount") {
      if (updatedItems[index].discountType === "percentage") {
        if (discount > 100) {
          swal({
            icon: "error",
            title: "Invalid Discount",
            text: "Percentage discount cannot exceed 100%.",
          });
          updatedItems[index].discount = "0";
          discount = 0;
        }
      } else {
        if (discount > subtotal) {
          swal({
            icon: "error",
            title: "Invalid Discount",
            text: "The discount should not exceed the subtotal.",
          });
          updatedItems[index].discount = "0";
          discount = 0;
        }
      }
    }

    // Calculate effective discount amount
    let effectiveDiscount = 0;
    if (updatedItems[index].discountType === "percentage") {
      effectiveDiscount = (discount / 100) * subtotal;
    } else {
      effectiveDiscount = discount;
    }

    subtotal -= effectiveDiscount;

    updatedItems[index].subtotal = subtotal;

    // Check if quantity exceeds remaining stock
    // if (field === "quantity") {
    //   const quantity = numericValue;
    //   const remaining =
    //     parseFloat(String(updatedItems[index].remaining).replace(/,/g, "")) ||
    //     0;

    //   if (quantity > remaining.toFixed(2)) {
    //     const wrapper = document.createElement("div");
    //     wrapper.className = "center-swal-text";
    //     wrapper.innerHTML = `The quantity inputted must not exceed the available stock (${
    //       String(remaining).includes(".") ? remaining.toFixed(2) : remaining
    //     }).`;
    //     swal({
    //       icon: "error",
    //       title: "Invalid Quantity",
    //       content: wrapper,
    //     });
    //     updatedItems[index].quantity = "0";
    //     updatedItems[index].netWeight = "0";
    //     updatedItems[index].subtotal = 0;
    //   }
    // }

    setItems(updatedItems);
    calculateTotals(updatedItems);
  };

  const calculateTotals = (
    items,
    currentVatPercent = vatPercent,
    currentTaxRate = selectedTaxRate,
    currentWeighingFee = displayWeighingFee,
    currentOtherFee = displayOtherFee,
    currentOtherFees = otherFees,
    currentDisplayDiscount = displayDiscount,
    currentModalDiscountType = modalDiscountType,
    currentIsSpecialTax = isSpecialTax,
  ) => {
    let totalDiscount = 0;
    let totalAmount = 0;
    let totalQuantity = 0;
    let totalMoisture = 0;
    let totalNetWeight = 0;
    let totalWeightedAmount = 0;
    let totalMoistureAmount = 0;
    let totalNetWeightAmount = 0;

    items.forEach((item) => {
      const quantity = parseFloat(String(item.quantity).replace(/,/g, "")) || 0;
      const moisture = parseFloat(String(item.moisture).replace(/,/g, "")) || 0;
      const netWeight =
        parseFloat(String(item.netWeight).replace(/,/g, "")) || 0;
      const unitPrice =
        parseFloat(String(item.unitPrice).replace(/,/g, "")) || 0;
      let discount = parseFloat(String(item.discount).replace(/,/g, "")) || 0;

      totalQuantity += quantity;
      totalMoisture += Math.round((moisture / 100) * quantity);
      totalNetWeight += netWeight;

      const weightedAmount = quantity * unitPrice;
      const moistureAmount = Math.round(
        quantity * (moisture / 100) * unitPrice,
      );
      const netWeightAmount = netWeight * unitPrice;

      totalWeightedAmount += weightedAmount;
      totalMoistureAmount += moistureAmount;
      totalNetWeightAmount += netWeightAmount;

      if (item.discountType === "percentage") {
        discount = Math.round((discount / 100) * netWeightAmount);
      }
      if (!isNaN(discount) && discount > netWeightAmount) discount = 0;

      totalDiscount += discount;
      totalAmount += item.subtotal;
    });

    setTotalItemDiscount(totalDiscount);
    setTotalQuantity(totalQuantity);
    setTotalMoisture(totalMoisture);
    setTotalNetWeight(totalNetWeight);
    setTotalWeightedAmount(totalWeightedAmount);
    setTotalMoistureAmount(totalMoistureAmount);
    setTotalNetWeightAmount(totalNetWeightAmount);

    // Save raw product total for discount modal validation
    totalAmountUseRef.current = totalAmount;

    // Transaction discount — always use the passed-in values, never stale state
    let discountAmount = 0;
    if (currentDisplayDiscount > 0) {
      if (currentModalDiscountType === "percentage") {
        discountAmount = parseFloat(
          (currentDisplayDiscount / 100) * totalAmount,
        );
      } else {
        discountAmount = parseFloat(currentDisplayDiscount);
      }
    }
    discountAmountPhp.current = parseFloat(discountAmount.toFixed(2));

    // Gross Amount (VAT & Withholding Tax base — products only)
    const baseAmount = totalAmount - discountAmount;
    setPreVatBase(baseAmount);

    // const vat = parseFloat(currentVatPercent) || 0;
    const vat = currentIsSpecialTax ? 0 : parseFloat(currentVatPercent) || 0;
    const vatAmount = vat > 0 ? (vat / 100) * baseAmount : 0;

    // const tRate = parseFloat(currentTaxRate) || 0;
    const tRate = currentIsSpecialTax ? 0 : parseFloat(currentTaxRate) || 0;
    const taxAmount = tRate > 0 ? (tRate / 100) * baseAmount : 0;

    // Non-taxable fees added last
    const wFee = parseFloat(currentWeighingFee) || 0;
    const oFee = parseFloat(currentOtherFee) || 0;
    const namedFees = (currentOtherFees || []).reduce(
      (sum, fee) => sum + (parseFloat(fee.feeAmount) || 0),
      0,
    );

    // Special tax (Gross Amount * 0.1088)
    const specialTaxAmount = currentIsSpecialTax ? baseAmount * 0.1088 : 0;

    const finalTotal =
      baseAmount +
      vatAmount -
      taxAmount +
      specialTaxAmount -
      wFee -
      oFee -
      namedFees;

    setTotalAmount(finalTotal);
  };

  const handleDiscountButton = (index) => {
    const updatedItems = [...items];
    const currentDiscountType = updatedItems[index].discountType;

    updatedItems[index].discountType =
      currentDiscountType === "percentage" ? "fixed" : "percentage";

    if (isNaN(currentDiscountType)) {
      updatedItems[index].discount = "";
    } else if (currentDiscountType === "percentage") {
      updatedItems[index].discount = (
        parseFloat(updatedItems[index].discount) * 100
      ).toFixed(2);
    } else {
      updatedItems[index].discount = (
        parseFloat(updatedItems[index].discount) / 100
      ).toFixed(2);
    }

    setItems(updatedItems);
  };

  // const toggleEdit = (index) => {
  //   setEditIndex(index === editIndex ? null : index);
  // };

  const removeItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    setItems(updatedItems);
    calculateTotals(updatedItems);
  };

  const handleDiscountIcon = () => {
    setModalDiscount(!modalDiscount);
    setModalDiscountType(!modalDiscount ? "percentage" : "fixed");
  };

  const handleAddDiscount = () => {
    const discountValue = inputDiscount.replace(/,/g, "");
    const discount = parseFloat(discountValue) || 0;
    const discountType = modalDiscountType;
    const currentTotalAmount = parseFloat(totalAmountUseRef.current) || 0;

    if (discountType === "percentage") {
      if (discount > 100) {
        swal({
          icon: "error",
          title: "Invalid Discount",
          text: "Percentage discount cannot exceed 100%.",
        });
        setInputDiscount("0");
        return;
      }
    } else {
      if (discount > currentTotalAmount) {
        swal({
          icon: "error",
          title: "Invalid Discount",
          text: "Transaction discount should not exceed the total amount.",
        });
        setInputDiscount("0");
        return;
      }
    }

    const newDisplayDiscount = parseFloat(discountValue) || 0;
    setDisplayDiscount(newDisplayDiscount);
    // Pass new discount value explicitly — state hasn't updated yet
    calculateTotals(
      items,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      displayOtherFee,
      otherFees,
      newDisplayDiscount,
      modalDiscountType,
    );
    setTransactionDiscountModal(false);
  };

  const handleAddShippingFee = () => {
    const shippingFee = parseFloat(inputShippingFee.replace(/,/g, "")) || 0;
    const currentTotalAmount = parseFloat(totalAmount) || 0;

    const newTotalAmount = currentTotalAmount + shippingFee;
    setTotalAmount(newTotalAmount);
    totalAmountUseRef.current = newTotalAmount;
    setDisplayShippingFee(parseFloat(inputShippingFee.replace(/,/g, "")));
    setShippingFeeModal(false);
  };

  const handleRemoveDiscount = (e) => {
    e.stopPropagation();
    setDisplayDiscount(0);
    setInputDiscount("");
    // Pass 0 for discount explicitly
    calculateTotals(
      items,
      vatPercent,
      selectedTaxRate,
      displayWeighingFee,
      displayOtherFee,
      otherFees,
      0,
      modalDiscountType,
    );
  };

  const handleRemoveShippingFee = (e) => {
    const shippingFeeValue = parseFloat(displayShippingFee) || 0;
    const newTotalAmount = parseFloat(totalAmount) - shippingFeeValue;
    setTotalAmount(newTotalAmount);
    totalAmountUseRef.current = newTotalAmount;
    setDisplayShippingFee(0);
    e.stopPropagation();
  };

  // Replaced by warnIfNoCutoff (utils/cutoffDateValidation)
  // const dateValidation = async (selectedDate, clearField, dateLabel) => {
  //   try {
  //     const res = await axios.get(`${BASE_URL}/cutoff/dateValidation`, {
  //       params: {
  //         date: selectedDate,
  //       },
  //     });
  // if (res.data == false) {
  //   swal({
  //     icon: "error",
  //     title: `Invalid ${dateLabel}`,
  //     text: `Please Create Cutoff for this Date (${format(
  //       selectedDate,
  //       "MM/dd/yyyy"
  //     )})`,
  //     // buttons: false,
  //     // timer: 2000,
  //   }).then(() => {
  //     clearField("");
  //   });
  // }
  //   } catch (error) {
  //     console.error(error);
  //   }
  // };

  const validateDueDateGreaterThanInvoiceDate = (dueDate, invoiceDate) => {
    if (!dueDate || !invoiceDate) return true;

    const due = new Date(dueDate);
    const invoice = new Date(invoiceDate);

    if (due <= invoice) {
      swal({
        icon: "error",
        title: "Invalid Due Date",
        text: "Due Date must be greater than Invoice Date",
      }).then(() => {
        setSelectedDueDate("");
        // Keep the rejection so Save stays blocked until a valid Due Date is chosen.
        setDueDateError("Due Date must be greater than Invoice Date.");
      });
      return false;
    }
    return true;
  };

  const handleDueDateChange = (date) => {
    // const dueDate = date;
    // setSelectedDueDate(dueDate);

    if (validateDueDateGreaterThanInvoiceDate(date, selectedInvoiceDate)) {
      setSelectedDueDate(date);
      setDueDateError("");
      warnIfNoCutoff(date, "Due Date");
    }
    // if (dueDate) {
    //   dateValidation(dueDate, setSelectedDueDate);
    // }
    // const isWithinCutoff = cutOffData.some((cutoff) => {
    //   const fromDate = new Date(cutoff.from);
    //   const toDate = new Date(cutoff.to);
    //   const selectedDate = new Date(dueDate);

    //   return selectedDate >= fromDate && selectedDate <= toDate;
    // });

    // if (isWithinCutoff) {
    //   swal({
    //     icon: "warning",
    //     title: "Due Date Conflict",
    //     text: "The due date you selected is already posted in the cutoff period!",
    //     confirmButtonColor: "#d33",
    //   }).then(() => {
    //     setSelectedDueDate("");
    //   });
    // }
  };

  const handleDueInvoiceDate = (date) => {
    const invoiceDate = date;
    setSelectedInvoiceDate(invoiceDate);
    setDueDateError("");
    // Field was emptied (typing/backspace): nothing to validate, and the
    // auto-computed Due Date has no Invoice Date to follow anymore.
    if (!invoiceDate) {
      setSelectedDueDate("");
      return;
    }
    if (invoiceDate) {
      const DueDate = addDays(new Date(invoiceDate), 14);
      setSelectedDueDate(DueDate);
      // dateValidation(invoiceDate, setSelectedInvoiceDate, "Invoice Date");
      warnIfNoCutoff(invoiceDate, "Invoice Date");
    }

    const isWithinCutoff = cutOffData.some((cutoff) => {
      const fromDate = new Date(cutoff.from);
      const toDate = new Date(cutoff.to);
      const selectedDate = new Date(invoiceDate);

      return selectedDate >= fromDate && selectedDate <= toDate;
    });

    if (isWithinCutoff) {
      swal({
        icon: "warning",
        title: "Invoice Date Conflict",
        text: "The invoice date you selected is already posted in the cutoff period!",
        confirmButtonColor: "#d33",
      }).then(() => {
        setSelectedInvoiceDate("");
        setSelectedDueDate("");
      });
    }
  };

  // Due Date typing: a complete date earlier than the Invoice Date is silently
  // ignored by react-datepicker (minDate makes that day disabled): onChange never
  // fires, the old Due Date stays selected and the text snaps back on blur. Flag
  // it here and drop the stale selection so it can't be saved by mistake.
  const handleDueDateRaw = (e) => {
    const next = maskTypedDate(e);
    if (next === null) return;

    if (!/^\d{2}\/\d{2}\/\d{4}$/.test(next)) {
      // Still typing: keep a pending error until a valid date is entered (or the
      // field is emptied), so it can't be dodged by erasing a character and saving.
      if (next === "") setDueDateError("");
      return;
    }

    const typed = parseDateFns(next, DATE_INPUT_FORMAT, new Date());
    if (isValidDateFns(typed) && selectedInvoiceDate) {
      const minDue = new Date(selectedInvoiceDate);
      minDue.setHours(0, 0, 0, 0);
      typed.setHours(0, 0, 0, 0);
      if (typed < minDue) {
        setSelectedDueDate("");
        setDueDateError(
          `Due date cannot be earlier than the invoice date (${format(minDue, DATE_DISPLAY_FORMAT)}).`,
        );
        return;
      }
    }
    setDueDateError("");
  };

  const CancelInvoice = () => {
    navigate("/sales/invoices");
  };

  // Due Date check run when Save is clicked. Returns the message to show, or an
  // empty string when the Due Date is fine:
  //  - a Due Date that was rejected while typing/selecting (the field was cleared
  //    and the message is still pending in dueDateError), or
  //  - a selected Due Date that is earlier than the Invoice Date.
  const getDueDateProblem = () => {
    if (dueDateError) return dueDateError;
    if (!selectedDueDate || !selectedInvoiceDate) return "";

    const due = new Date(selectedDueDate);
    const invoice = new Date(selectedInvoiceDate);
    if (Number.isNaN(due.getTime()) || Number.isNaN(invoice.getTime())) {
      return "";
    }

    due.setHours(0, 0, 0, 0);
    invoice.setHours(0, 0, 0, 0);
    if (due < invoice) {
      return `Due date cannot be earlier than the invoice date (${format(invoice, DATE_DISPLAY_FORMAT)}).`;
    }
    return "";
  };

  const add = async (e) => {
    e.preventDefault();
    // 🚫 STOP if DR is invalid
    if (isTextDrValidationVisible === true) {
      swal({
        icon: "error",
        title: "DR number Already Exist",
        text: "Please enter a valid DR number.",
      });

      // 🎯 focus the input
      drInputRef.current?.focus();

      return; // ⛔ stop everything here
    }
    // STOP if the Due Date is invalid (e.g. earlier than the Invoice Date)
    const dueDateProblem = getDueDateProblem();
    if (dueDateProblem) {
      swal({
        icon: "error",
        title: "Invalid Due Date",
        text: dueDateProblem,
      });
      return; // do not save
    }
    const form = e.currentTarget;

    if (form.checkValidity() === false) {
      e.preventDefault();
      e.stopPropagation();
      swal({
        icon: "error",
        title: "Fields are required",
        text: "Please fill in the red text fields.",
      });
    } else {
      // dateValidation(
      //   selectedInvoiceDate,
      //   setSelectedInvoiceDate,
      //   "Invoice Date",
      // );

      // Check if there are any valid items (products with quantity > 0)
      const validItems = items.filter(
        (item) =>
          item.productName &&
          item.productName.value &&
          item.quantity &&
          !isNaN(parseFloat(item.quantity)) &&
          parseFloat(item.quantity) > 0,
      );

      // Validation for no valid items
      if (validItems.length === 0) {
        const wrapper = document.createElement("div");
        wrapper.className = "center-swal-text";
        wrapper.innerHTML =
          "Please add at least one item with a quantity greater than zero.";
        swal({
          icon: "error",
          title: "No Valid Items",
          content: wrapper,
        });
        return;
      }

      // Validation for empty moisture on valid items
      const itemsWithEmptyMoisture = validItems
        .map((item) => ({ item, rowNumber: items.indexOf(item) + 1 }))
        .filter(
          ({ item }) =>
            item.moisture === "" ||
            item.moisture === null ||
            item.moisture === undefined,
        );

      if (itemsWithEmptyMoisture.length > 0) {
        const rowLabels = itemsWithEmptyMoisture
          .map(
            ({ item, rowNumber }) =>
              `Row ${rowNumber} - ${item.productName?.label || "Unknown Product"}`,
          )
          .join("\n");
        swal({
          icon: "error",
          title: "Missing Moisture",
          text: `Please fill in the Moisture field for the following item(s) before saving.\nEnter 0 if there is no moisture deduction.\n\n${rowLabels}`,
        });
        return;
      }

      // Check if all items have zero unit price (which would result in zero total)
      const hasNonZeroUnitPrice = validItems.some((item) => {
        const unitPrice =
          parseFloat(String(item.unitPrice).replace(/,/g, "")) || 0;
        return unitPrice > 0;
      });

      // Only validate total amount > 0 if there are items with non-zero unit prices
      if (hasNonZeroUnitPrice && totalAmount <= 0) {
        const wrapper = document.createElement("div");
        wrapper.className = "center-swal-text";
        wrapper.innerHTML =
          "The Total Amount must be greater than zero. Please check your input.";
        swal({
          icon: "error",
          title: "Invalid Amount",
          content: wrapper,
        });
        return;
      }

      // Validation for negative Total Amount
      if (totalAmount < 0) {
        swal({
          icon: "error",
          title: "Invalid Total Amount",
          text: "The Total Amount cannot be less than 0",
        });
        return;
      }

      swal({
        title: "Create this new sale?",
        text: "",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      }).then((confirmed) => {
        if (confirmed) {
          setIsSaving(true);
          const shipAmountFormat = parseNumber(shipmentFee) || 0;

          const payload = {
            transactionId,
            clientTransactionId,
            selectedCustomer: selectedCustomer?.value,
            selectedMethod,
            selectedDueDate,
            selectedInvoiceDate,
            inputPaymentTerms,
            remarks,
            drNumber,
            poNumber,
            containerNumber,
            pier,
            userLoggedID,
            selectedDestination,
            selectedCurrency,
            currencyRate,
            selectedWarehouse,
            selectedSubject3,
            shipAmountFormat,
            vatPercent,
            tax_id: selectedTaxId || null,
            tax_rate: parseFloat(selectedTaxRate || 0),
            weighingFee: displayWeighingFee || 0,
            otherFee: displayOtherFee || 0,
            otherFees: JSON.stringify(otherFees),
            isSpecialTax: isSpecialTax,
            // items: items.map((item) => ({
            //   product_id: item.productName,
            //   quantity: item.quantity,
            //   unitPrice: item.unitPrice,
            //   discount: item.discount,
            //   discountType: item.discountType,
            //   subtotal: item.subtotal,
            //   averagePrice: item.averagePrice,
            //   salesProfit: item.sales_profit,
            // })),
            items: items
              .filter(
                (item) =>
                  item.productName &&
                  item.productName.value &&
                  item.quantity &&
                  !isNaN(parseFloat(item.quantity)) &&
                  parseFloat(item.quantity) > 0,
                // REMOVE THESE UNIT PRICE FILTERS:
                // && item.unitPrice !== undefined
                // && item.unitPrice !== ""
                // && !isNaN(parseFloat(item.unitPrice || 0))
              )
              .map((item) => ({
                stock_management_id:
                  item.stockDetails?.[0]?.stock_management_id || "",
                product_id: item.productName?.value,
                quantity: parseFloat(String(item.quantity).replace(/,/g, "")),
                moisture:
                  parseFloat(String(item.moisture).replace(/,/g, "")) || 0,
                netWeight:
                  parseFloat(String(item.netWeight).replace(/,/g, "")) || 0,
                unitPrice:
                  parseFloat(String(item.unitPrice).replace(/,/g, "")) || 0,
                discount:
                  parseFloat(String(item.discount).replace(/,/g, "")) || 0,
                discountType: item.discountType,
                subtotal: item.subtotal,
                averagePrice: item.averagePrice,
                salesProfit: item.sales_profit,
              })),
            totalAmount: totalAmount.toFixed(2),
            transactionDiscount: displayDiscount,
            transactionDiscountType: modalDiscountType,
            shippingFee: displayShippingFee,
            totalItemDiscount,
            amount,
            qty,
          };

          axios
            .post(`${BASE_URL}/invoice/create`, payload)
            .then((res) => {
              setIsSaving(false);
              if (res.status === 200) {
                swal({
                  title: "Success",
                  text: "Sales invoice created successfully",
                  icon: "success",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                }).then(() => {
                  navigate("../sales/invoices");
                });
              }
              // else if (res.status === 201) {
              //   swal({
              //     title: "Opppss!",
              //     text: "Cutoff already posted for the due date you selected",
              //     icon: "warning",
              //     buttons: false,
              //     timer: 2000,
              //     dangerMode: true,
              //   });
              // }
              else if (res.status === 205) {
                swal({
                  title: "Insufficient Stock",
                  text: res.message,
                  icon: "error",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                });
              } else {
                swal({
                  title: "Something Went Wrong",
                  text: "Please contact your support immediately",
                  icon: "error",
                  buttons: false,
                  timer: 2000,
                  dangerMode: true,
                });
              }
            })
            .catch((error) => {
              setIsSaving(false);
              if (error.response && error.response.status === 409) {
                swal({
                  icon: "error",
                  title: "Transaction ID Conflict",
                  text: "The transaction ID you entered already exists in the system. Please use a unique identifier.",
                });
              }
            });
        }
      });
    }
    setValidated(true);
  };

  const handleChangeCurrency = (value) => {
    const curr = currencyData.find((data) => String(data.id) === String(value));
    setSelectedCurrency(curr.id);
    const newRate = parseFloat(curr.currency_rate) || 1;
    setCurrencyRate(newRate);

    // Recalculate prices for all rows that already have a product selected.
    // original_php_price holds the raw PHP value set at selection time, so
    // dividing by the new rate always gives the correct converted price
    // regardless of how many currency switches have happened.
    const updatedItems = items.map((item) => {
      if (!item.productName || !item.productName.value) return item;
      const phpPrice = parseFloat(item.original_php_price) || 0;
      if (phpPrice === 0) return item;

      const convertedPrice = phpPrice / newRate;

      // Recompute subtotal with the new unit price (mirrors handleInputQTY logic)
      const netWeight =
        parseFloat(String(item.netWeight).replace(/,/g, "")) || 0;
      const discount = parseFloat(String(item.discount).replace(/,/g, "")) || 0;
      let subtotal = netWeight * convertedPrice;
      const effectiveDiscount =
        item.discountType === "percentage"
          ? (discount / 100) * subtotal
          : discount;
      subtotal -= effectiveDiscount;

      return {
        ...item,
        averagePrice: convertedPrice,
        unitPrice: convertedPrice,
        subtotal,
      };
    });

    setItems(updatedItems);
    calculateTotals(updatedItems);
  };

  console.log(currencyRate);

  // Item List input validation
  const inputFieldsValidation = () => {
    const requiredFields = [
      selectedMethod,
      // selectedDueDate,
      selectedInvoiceDate,
      selectedDestination ?? "Local",
      selectedCurrency,
      // inputPaymentTerms,
      // currencyRate,
    ];

    if (requiredFields.some((field) => !field)) {
      return true;
    }
    return false;
  };

  // Handle Item List input change
  const handleInputChange = (index, field, value) => {
    if (inputFieldsValidation()) {
      swal({
        icon: "error",
        title: "Missing Required Fields",
        text: "Please fill out the required invoice details above before adding items.",
      });
      setValidated(true);
      return;
    }
    handleInputQTY(index, field, value);
    setValidated(false);
  };

  // Customer options for dropdown select
  const customerOptions = useMemo(
    () =>
      customerData.map((data) => ({
        value: data.customer_id,
        label:
          data.company_name?.trim() ||
          [data.first_name?.trim(), data.last_name?.trim()]
            .filter(Boolean)
            .join(" "),
      })),
    [customerData],
  );

  // Commented for re-usable currencyList (check numberFormatter.jsx)
  // Currency List
  // const currencyList = {
  //   PHP: "Philippine Peso (Philippines)",
  //   USD: "US Dollar (United States)",
  //   CNY: "Chinese Yuan (China)",
  //   HKD: "Hong Kong Dollar (Hong Kong)",
  //   EUR: "Euro (European Union)",
  //   JPY: "Japanese Yen (Japan)",
  // };

  // For Item list input select width
  const selectProductWidth = Math.max(
    ...items.map((item) => item.productName.label?.length || 0),
  );

  // Lets the Product Name select wrap long names onto multiple lines
  // (control grows taller) and widens the open dropdown so wrapped
  // option text reads naturally. Layered on top of selectCustomStyles
  // so the shared style file and the other Select instance that uses
  // it (the customer select above) are untouched.
  const withWrappableProductStyles = (baseStyles) => ({
    ...baseStyles,
    control: (provided, state) => ({
      ...(baseStyles.control ? baseStyles.control(provided, state) : provided),
      height: "auto",
      minHeight: "38px",
      alignItems: "flex-start",
    }),
    valueContainer: (provided, state) => ({
      ...(baseStyles.valueContainer
        ? baseStyles.valueContainer(provided, state)
        : provided),
      flexWrap: "wrap",
      overflow: "visible",
      paddingTop: "6px",
      paddingBottom: "6px",
    }),
    singleValue: (provided, state) => ({
      ...(baseStyles.singleValue
        ? baseStyles.singleValue(provided, state)
        : provided),
      position: "relative",
      whiteSpace: "normal",
      overflow: "visible",
      textOverflow: "unset",
      wordBreak: "break-word",
      maxWidth: "100%",
    }),
    menu: (provided, state) => ({
      ...(baseStyles.menu ? baseStyles.menu(provided, state) : provided),
      width: "max-content",
      minWidth: "100%",
      maxWidth: "440px",
    }),
    // The menu is portalled to document.body (menuPortalTarget on the Select),
    // where react-select gives its wrapper z-index: 1. The sticky header row
    // (thead/th) is z-index: 2, so it painted over the menu and hid its last
    // options whenever the menu opened across the header. Lift the portal
    // above the header row.
    menuPortal: (provided, state) => ({
      ...(baseStyles.menuPortal
        ? baseStyles.menuPortal(provided, state)
        : provided),
      zIndex: 9999,
    }),
    option: (provided, state) => ({
      ...(baseStyles.option ? baseStyles.option(provided, state) : provided),
      whiteSpace: "normal",
      wordBreak: "break-word",
    }),
  });

  const getPriceIndicator = (unitPrice, averagePrice) => {
    if (!unitPrice || !averagePrice) return null;

    const unitPriceNum = parseFloat(
      parseFloat(String(unitPrice).replace(/,/g, "") || 0).toFixed(4),
    );
    const avgPriceNum = parseFloat(
      parseFloat(String(averagePrice).replace(/,/g, "") || 0).toFixed(4),
    );

    if (unitPriceNum === avgPriceNum) {
      return { label: "Same Price", color: "text-success", srp: avgPriceNum };
    } else if (unitPriceNum > avgPriceNum) {
      return {
        // Old Label
        // label: "Above SRP",
        label: "Above Supplier Price",
        color: "text-danger",
        srp: avgPriceNum,
        symbol: currencySymbol,
      };
    } else {
      return {
        // Old Label
        // label: "Below SRP",
        label: "Below Supplier Price",
        color: "text-info",
        srp: avgPriceNum,
        symbol: currencySymbol,
      };
    }
  };

  // commented kasi nagcacause ng bug sa item list
  // const getTableRows = () => {
  //   const minRows = 5;
  //   const filledItems = [...items];
  //   while (filledItems.length < minRows) {
  //     filledItems.push({
  //       productCode: "",
  //       productName: "",
  //       remaining: "",
  //       averagePrice: "",
  //       quantity: "",
  //       moisture: "",
  //       netWeight: "",
  //       unitPrice: "",
  //       sales_profit: "",
  //       discount: "",
  //       subtotal: 0,
  //       discountType: "percentage",
  //     });
  //   }
  //   return filledItems;
  // };

  //Remove redundant useEffect

  useEffect(() => {
    if (!selectedInvoiceDate) return;

    const dueDate = addDays(selectedInvoiceDate, 14);

    setSelectedDueDate(dueDate);
  }, [selectedInvoiceDate, setSelectedDueDate]);

  const [isTextDrValidationVisible, setIsTextDrValidationVisible] =
    useState(false);

  const handleValidateDR = (e) => {
    const drValue = e.target.value.trim();
    setDrNumber(drValue);
    if (!drValue) return;

    const delayDebounce = setTimeout(() => {
      checkDrNumber(drValue)
        .then((res) => {
          if (res.data === false) {
            setIsTextDrValidationVisible(false); //check
          } else {
            setIsTextDrValidationVisible(true); // X
          }
        })
        .catch((err) => {
          console.error(err);
        });
    }, 500); // ⏱️ .5 seconds delay

    return () => clearTimeout(delayDebounce);
  };

  const handleSpecialTax = (e) => {
    const isChecked = e.target.checked;
    setIsSpecialTax(isChecked);

    let newVat = vatPercent;
    let newTaxId = selectedTaxId;
    let newTaxRate = selectedTaxRate;

    if (isChecked) {
      setBackupVatPercent(vatPercent);
      setBackupTaxId(selectedTaxId);
      setBackupTaxRate(selectedTaxRate);

      newVat = 0;
      newTaxId = "";
      newTaxRate = 0;
    } else {
      newVat = backupVatPercent;
      newTaxId = backupTaxId;
      newTaxRate = backupTaxRate;
    }

    setVatPercent(newVat);
    setSelectedTaxId(newTaxId);
    setSelectedTaxRate(newTaxRate);

    calculateTotals(
      items,
      newVat,
      newTaxRate,
      displayWeighingFee,
      displayOtherFee,
      otherFees,
      displayDiscount,
      modalDiscountType,
      isChecked,
    );
  };

  return (
    <div className="h-100 w-100 border bg-white custom-container">
      <style>{`
        /* Bootstrap gives a focused/validated .input-group field (Moisture,
           Discount) a z-index up to 5, which is higher than the sticky
           column headers' z-index of 2 below — so on scroll that field
           would paint on top of the header text instead of staying behind
           it. Giving each body cell its own stacking context (with a
           z-index lower than the header) contains that escalation inside
           the cell so it can never escape above the sticky header row. */
        .item-list-table tbody td {
          position: relative;
          z-index: 0;
        }
      `}</style>
      <Form noValidate validated={validated} onSubmit={add}>
        <div className="w-100 p-2 d-flex flex-row justify-content-between">
          <div className="d-flex flex-column title-custom">
            <span className="fs-3">
              <Link to="/sales/invoices" className="text-dark mx-2">
                <i class="fa-solid fa-arrow-left"></i>
              </Link>
              SALES INVOICE
            </span>
          </div>
        </div>
        <div className="container-fluid mt-3">
          <div className="row mx-auto">
            <div className="d-none col-sm mb-3">
              <span>Transaction ID</span>
              <Form.Control
                type="text"
                name=""
                id=""
                className="form-control custom-form-height"
                readOnly
                value={transactionId}
              />
            </div>
            <div className="col-sm mb-3">
              <span>Transaction ID</span>
              {/* Display only - generated by the server (SI-YY-MM-0001) */}
              <Form.Control
                type="text"
                name=""
                id=""
                className="form-control custom-form-height"
                value={clientTransactionId}
                placeholder="Generating..."
                readOnly
              />
              <small className="text-muted">
                Final number is assigned on save.
              </small>
            </div>
            <div className="col-sm">
              <span>
                Warehouse <span className="text-danger">*</span>
              </span>

              <Form.Select
                name=""
                id=""
                className="form-select custom-form-height"
                required
                value={selectedWarehouse}
                onChange={(e) => {
                  const warehouseId = e.target.value;
                  setSelectedWarehouse(warehouseId);
                  fetchDataProduct(warehouseId);
                }}
              >
                <option value="0" selected disabled>
                  Select Warehouse
                </option>
                {warehouseData.map((data, i) => (
                  <option key={i} value={data.warehouse_id}>
                    {`${data.name}`}
                  </option>
                ))}
              </Form.Select>

              {/*  */}
            </div>
          </div>
          <div className="row mx-auto">
            <div className="col-sm mb-3">
              <span>
                Customer <span className="text-danger">*</span>
              </span>
              {/* <Form.Select
                name=""
                id=""
                className="form-select custom-form-height"
                required
                onChange={(e) => {
                  setSelectedCustomer(e.target.value);
                }}
                onMouseDown={(e) => {
                  if (customerData.length === 0) {
                    e.preventDefault();
                    swal({
                      icon: "warning",
                      title: "No Customer Found",
                      text: "No customers found. Please create one first.",
                    });
                    return;
                  }
                }}
                value={selectedCustomer}
              >
                <option value="" selected disabled>
                  Select Customer
                </option>
                {customerData.map((data, i) => (
                  <option key={i} value={data.customer_id}>
                    {data.type === "company"
                      ? data.company_name
                      : `${data.first_name} ${data.last_name}`}
                  </option>
                ))}
              </Form.Select> */}
              <CustomerSelect
                options={customerOptions}
                value={selectedCustomer}
                onChange={(selectedOption) => {
                  setSelectedCustomer(selectedOption);

                  const customer = customerData.find(
                    (data) => data.customer_id === selectedOption.value,
                  );

                  if (customer) {
                    setSelectedDestination(customer.destination || "Local");
                    // Auto-select Currency and Rate
                    if (customer.currency_id) {
                      // Reuse existing function to set both Currency ID and Currency Rate
                      handleChangeCurrency(customer.currency_id);
                    }
                    const fetchedVat = parseFloat(customer.vat_percent) || 0;
                    setVatPercent(fetchedVat);
                    setSelectedTaxId("");
                    setSelectedTaxRate(0);
                    calculateTotals(
                      items,
                      fetchedVat,
                      0,
                      displayWeighingFee,
                      displayOtherFee,
                      otherFees,
                      displayDiscount,
                      modalDiscountType,
                    );
                  }

                  // Old Customer Config
                  // const findCustomerDestination = customerData.find(
                  //   (item) => item.customer_id === selectedOption?.value,
                  // ).destination;
                  // setSelectedCustomer(selectedOption);
                  // setSelectedDestination(findCustomerDestination ?? "Local");
                }}
                onMenuOpen={() => {
                  if (customerData.length === 0) {
                    swal({
                      icon: "warning",
                      title: "No Customer Found",
                      text: "No customers found. Please create one first.",
                    });
                    return;
                  }
                }}
                menuIsOpen={customerData.length === 0 ? false : undefined}
                placeholder={`Select Customer`}
                styles={themeSelectStyles(
                  selectCustomStyles(selectedCustomer, validated, "0.3rem"),
                )}
                required
                isSearchable
              />
            </div>

            <div className="col-sm mb-3">
              <span>
                Payment Method <span className="text-danger">*</span>
              </span>
              <Form.Select
                name=""
                id=""
                className="form-select custom-form-height"
                required
                onChange={(e) => setSelectedMethod(e.target.value)}
                value={selectedMethod}
              >
                <option value="" selected disabled>
                  Select Payment Method
                </option>
                <option value="Cash">Cash</option>
                <option value="Bank">Bank</option>
                <option value="Wallet">Wallet</option>
              </Form.Select>
            </div>
          </div>

          {selectedCustomer && (
            <>
              <div className="row mx-auto">
                <div className="col-sm mb-3">
                  <span>VAT %</span>
                  <Form.Control
                    type="text"
                    inputMode="decimal"
                    min="0"
                    className="form-control custom-form-height"
                    value={vatPercent}
                    disabled={isSpecialTax}
                    onChange={(e) => {
                      const value = e.target.value;
                      // Allow empty, digits, and at most one decimal point with up to 2 decimal places
                      if (!/^\d*\.?\d{0,2}$/.test(value)) return;
                      const numericValue = parseFloat(value) || 0;
                      // Clamp to 100
                      const clamped = numericValue > 100 ? 100 : numericValue;
                      setVatPercent(numericValue > 100 ? "100" : value);
                      calculateTotals(
                        items,
                        clamped,
                        selectedTaxRate,
                        displayWeighingFee,
                        displayOtherFee,
                        otherFees,
                        displayDiscount,
                        modalDiscountType,
                      );
                    }}
                  />
                </div>

                <div className="col-sm mb-3">
                  <span>Withholding Tax</span>
                  <Form.Select
                    className="form-select custom-form-height"
                    value={selectedTaxId}
                    disabled={isSpecialTax}
                    onChange={(e) => {
                      const selected = taxSettings.find(
                        (t) => String(t.id) === String(e.target.value),
                      );
                      const rate = selected ? selected.rate : 0;
                      setSelectedTaxId(e.target.value);
                      setSelectedTaxRate(rate);
                      calculateTotals(
                        items,
                        vatPercent,
                        rate,
                        displayWeighingFee,
                        displayOtherFee,
                        otherFees,
                        displayDiscount,
                        modalDiscountType,
                      );
                    }}
                  >
                    <option value="">None</option>
                    {taxSettings.map((tax) => (
                      <option key={tax.id} value={tax.id}>
                        {tax.name} - {tax.rate}%
                      </option>
                    ))}
                  </Form.Select>
                </div>
              </div>
            </>
          )}

          <div className="row mx-auto">
            <div className="col-sm mb-3">
              <span>
                Invoice Date <span className="text-danger">*</span>
              </span>
              {/* <Form.Control
                type="date"
                name=""
                id=""
                className="form-control custom-form-height"
                required
                onChange={handleDueInvoiceDate}
                value={selectedInvoiceDate}
              /> */}
              <DatePicker
                selected={
                  selectedInvoiceDate ? new Date(selectedInvoiceDate) : null
                }
                onChange={handleDueInvoiceDate}
                customInput={<TypedDateInput />}
                className="form-control custom-form-height"
                wrapperClassName="w-100"
                dateFormat={DATE_PICKER_FORMATS}
                strictParsing
                autoComplete="off"
                required
                // maxDate={new Date()}
              />
            </div>
            <div className="col-sm mb-3">
              <span>Due Date</span>
              {/* <Form.Control
                type="date"
                name=""
                id=""
                className="form-control custom-form-height"
                required
                onChange={handleDueDateChange}
                value={
                  selectedDueDate
                    ? format(new Date(selectedDueDate), "MMM/dd/yyyy")
                    : ""
                }
                    
                // min={currentDate}
              /> */}
              <DatePicker
                selected={selectedDueDate ? new Date(selectedDueDate) : null}
                onChange={handleDueDateChange}
                customInput={
                  <TypedDateInput
                    onTextChange={(text) => {
                      if (!/^\d{2}\/\d{2}\/\d{4}$/.test(text)) {
                        if (text === "") setDueDateError("");
                        return;
                      }
                      const typed = parseDateFns(
                        text,
                        DATE_INPUT_FORMAT,
                        new Date(),
                      );
                      if (isValidDateFns(typed) && selectedInvoiceDate) {
                        const minDue = new Date(selectedInvoiceDate);
                        minDue.setHours(0, 0, 0, 0);
                        typed.setHours(0, 0, 0, 0);
                        if (typed < minDue) {
                          setSelectedDueDate("");
                          setDueDateError(
                            `Due date cannot be earlier than the invoice date (${format(minDue, DATE_DISPLAY_FORMAT)}).`,
                          );
                          return;
                        }
                      }
                      setDueDateError("");
                    }}
                  />
                }
                className="form-control custom-form-height"
                wrapperClassName="w-100"
                dateFormat={DATE_PICKER_FORMATS}
                strictParsing
                autoComplete="off"
                minDate={
                  selectedInvoiceDate
                    ? new Date(selectedInvoiceDate)
                    : new Date()
                }
              />
              {dueDateError && (
                <div
                  className="text-danger mt-1"
                  style={{ fontSize: "0.8rem" }}
                >
                  {dueDateError}
                </div>
              )}
            </div>
          </div>
          <div className="row mx-auto">
            <div className="col-sm mb-3 d-flex flex-row justify-content-between">
              <div className="w-50 me-3">
                <span>
                  Designation <span className="text-danger">*</span>
                </span>
                <Form.Select
                  name=""
                  id=""
                  className="form-select custom-form-height "
                  required
                  onChange={(e) => setSelectedDestination(e.target.value)}
                  value={selectedDestination}
                  // style={{ pointerEvents: "none" }}
                >
                  <option value="" disabled>
                    Select Designation
                  </option>
                  <option value="Local">Local</option>
                  <option value="Overseas">Overseas</option>
                </Form.Select>
              </div>
              <div className="w-50">
                <span>
                  Currency <span className="text-danger">*</span>
                </span>
                {selectedCurrency &&
                selectedCurrency !== "11111111-1111-1111-1111-111111111111" ? (
                  <span className="text-muted mb-1">
                    {" "}
                    Current Rate: {currencyRate}
                  </span>
                ) : null}
                <Form.Select
                  name=""
                  id=""
                  className="form-select custom-form-height"
                  required
                  onChange={(e) => handleChangeCurrency(e.target.value)}
                  value={selectedCurrency}
                  // style={{ pointerEvents: "none" }}
                >
                  <option value="" selected disabled>
                    Select Currency
                  </option>
                  {currencyData.map((data, i) => (
                    <option key={i} value={data.id}>
                      {data.currency_name} - {currencyList[data.currency_name]}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div>
            <div className="col-sm mb-3 d-flex flex-row justify-content-between">
              {selectedCurrency &&
              selectedCurrency !== "11111111-1111-1111-1111-111111111111" ? (
                <div className="w-50 me-3 d-none">
                  <>
                    <span>
                      Currency Rate<span className="text-danger">*</span>
                    </span>
                    <Form.Control
                      type="text"
                      name=""
                      id=""
                      className="form-control custom-form-height"
                      required
                      onChange={handleCurrencyRateChange}
                      value={currencyRate}
                      readOnly
                    />
                  </>
                </div>
              ) : null}
              <div
                // className={`${
                //   selectedCurrency &&
                //   selectedCurrency != "11111111-1111-1111-1111-111111111111"
                //     ? "w-50"
                //     : "w-100"
                // }`}
                className="w-100"
              >
                <span>Payment Terms</span>
                <Form.Control
                  type="text"
                  name=""
                  id=""
                  className="form-control custom-form-height"
                  onChange={(e) => setInputPaymentTerms(e.target.value)}
                  value={inputPaymentTerms}
                />
              </div>
            </div>
          </div>
          <div className="row mx-auto">
            <div className="col-sm mb-3 d-flex flex-row justify-content-between">
              <div className="w-50 me-3">
                <Form.Label>DR Number</Form.Label>
                <div className="input-group">
                  <span className="input-group-text">
                    <Form.Check
                      checked={drNumberEnabled}
                      onChange={(e) => {
                        setDrNumberEnabled(e.target.checked);
                        if (e.target.checked) {
                          fetchDrNumberCode();
                        } else {
                          setDrNumber("");
                        }
                      }}
                    />
                  </span>
                  {/* <Form.Control
                    type="text"
                    name="dr-number"
                    id="dr-number"
                    value={drNumber}
                    className="form-control custom-form-height"
                    onChange={(e) => setDrNumber(e.target.value)}
                    style={{
                      backgroundColor: !drNumberEnabled ? "#e9ecef" : "white",
                      pointerEvents: "none",
                    }}
                  /> */}
                  <Form.Control
                    ref={drInputRef}
                    type="text"
                    name="dr-number"
                    id="dr-number"
                    value={drNumber}
                    className="form-control custom-form-height"
                    disabled={!drNumberEnabled}
                    onChange={handleValidateDR}
                  />
                  {drNumber &&
                    (!isTextDrValidationVisible ? (
                      <span className="input-group-text text-success">
                        <i className="fa-solid fa-check"></i>
                      </span>
                    ) : (
                      <span className="input-group-text text-danger">
                        <i className="fa-solid fa-x"></i>
                      </span>
                    ))}
                </div>
              </div>

              <div className="w-50">
                <span>PO Number</span>
                <Form.Control
                  type="text"
                  name=""
                  id=""
                  className="form-control custom-form-height"
                  onChange={(e) => setPoNumber(e.target.value)}
                  value={poNumber}
                />
              </div>
            </div>
          </div>
          <div className="row mx-auto">
            <div className="col-sm mb-3 d-flex flex-row justify-content-between">
              <div className="w-50 me-3">
                <span>Container Number</span>
                <Form.Control
                  type="text"
                  name=""
                  id=""
                  className="form-control custom-form-height"
                  onChange={(e) => setContainerNumber(e.target.value)}
                  value={containerNumber}
                />
              </div>
              <div className="w-50">
                <span>Pier</span>
                <Form.Control
                  type="text"
                  name=""
                  id=""
                  className="form-control custom-form-height"
                  onChange={(e) => setPier(e.target.value)}
                  value={pier}
                />
              </div>
            </div>
            {/* <div className="col-sm  mb-3 d-flex flex-row">
              <div className="w-50 me-3">
                <span>Liability Subject 3</span>
                <Form.Select
                  name=""
                  id=""
                  className="form-select custom-form-height"
                  onChange={(e) => {
                    setSelectedSubject3(e.target.value);
                    setIsAmountQtyDisabled(false);
                  }}
                  value={selectedSubject3}
                >
                  <option value="" selected disabled>
                    Select Subject
                  </option>
                  {subject3Data.map((data, i) => (
                    <option key={i} value={data.id}>
                      {data.account_name}
                    </option>
                  ))}
                </Form.Select>
              </div>
            </div> */}
          </div>
          <div className="row mx-auto">
            <div className="col-sm">
              <span>Remarks</span>
              <Form.Control
                as="textarea"
                onChange={(e) => setRemarks(e.target.value)}
                value={remarks}
                rows={3}
                maxLength={250}
              />
            </div>
            <div className="col-sm mb-3 d-flex flex-row justify-content-between">
              <div className="w-25">
                <span>Amount</span>
                <NumberInDecimals
                  type="text"
                  className="form-control custom-form-height"
                  onChange={(value) => shipmentAmount(value, "amount")}
                  decimals={2}
                  value={amount}
                  required={selectedSubject3}
                />
              </div>
              <span className="align-self-center mx-2">*</span>
              <div className="w-25">
                <span>Quantity</span>
                <NumberInDecimals
                  type="text"
                  className="form-control custom-form-height"
                  onChange={(value) => shipmentAmount(value, "qty")}
                  value={qty}
                  required={selectedSubject3}
                />
              </div>
              <span className="align-self-center mx-2">=</span>
              <div className="w-50">
                <span>Shipment Amount</span>
                <Form.Control
                  type="text"
                  className="form-control custom-form-height"
                  value={formatToTwoDecimal(shipmentFee)}
                  readOnly
                />
              </div>
            </div>
          </div>
        </div>
        <div className="container-fluid ">
          <div className="w-100 d-flex align-items-center mt-3 p-2">
            <h5>Item List</h5>
            <hr className="flex-grow-1 mx-3" />
          </div>
          <div
            className="w-100 mt-2 new-item-custom scrollable-contents"
            style={{ overflowX: "auto" }}
          >
            <table className="table table-bordered table-hover item-list-table">
              <thead
                className="table-light"
                style={{ position: "sticky", top: 0, zIndex: 2 }}
              >
                <tr>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Product Code
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Product Name<span className="text-danger">*</span>
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Remaining
                  </th>
                  {/* Hide since meron na supplier price indicator sa unit price */}
                  {/* <th className="px-4 py-2 text-nowrap">SRP</th> */}
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Unit Price<span className="text-danger">*</span>
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Qty<span className="text-danger">*</span>
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Moisture<span className="text-danger">*</span>
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Net Qty<span className="text-danger">*</span>
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Discount
                  </th>
                  <th
                    className="px-4 py-2 text-nowrap invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Subtotal
                  </th>
                  <th
                    className="p-2 invoice-items-th"
                    style={{
                      position: "sticky",
                      top: 0,
                      zIndex: 2,
                    }}
                  >
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>
                {items.map((item, index) => {
                  const priceIndicator = getPriceIndicator(
                    unitPriceInputs[index] ?? item?.unitPrice,
                    item?.averagePrice,
                  );
                  return (
                    <tr key={index}>
                      <td>
                        <input
                          type="text"
                          className="form-control form-control-sm p-2"
                          value={item?.productCode}
                          readOnly
                        />
                      </td>
                      <td className="z-1">
                        {/* Original Product Selection */}
                        {/* <Form.Select
                        value={item.productName}
                        onChange={(e) => {
                          if (inputFieldsValidation()) {
                            swal({
                              icon: "error",
                              title: "Missing Required Fields",
                              text: "Please fill out the required invoice details above before adding items.",
                            });
                            setValidated(true);
                            return;
                          }
                          handleProductChange(index, e.target.value);
                          setValidated(false);
                        }}
                        onMouseDown={(e) => {
                          if (productData.length === 0) {
                            e.preventDefault();
                            const wrapper = document.createElement("div");
                            wrapper.classList.add("center-swal-text");
                            wrapper.innerHTML =
                              "No products found. Please create a product first to proceed.";
                            swal({
                              icon: "warning",
                              title: "No Product Found",
                              content: wrapper,
                            });
                            return;
                          }
                        }}
                        required
                        disabled={!selectedCustomer || !selectedWarehouse}
                      >
                        <option value="" disabled>
                          Select Product
                        </option>
                        {getFilteredProductData(index).map((data) => (
                          <option
                            key={data.product_id}
                            value={data.product_id}
                          >
                            {data.product_name}
                          </option>
                        ))}
                      </Form.Select> */}

                        {/* Second Product Selection (Revision) */}
                        {/* <Select
                          options={getFilteredProductData(index).map(
                            (data) => ({
                              value: data.product_id,
                              label: data.product_name,
                            }),
                          )}
                          classNamePrefix="item-list-table-select"
                          value={item.productName}
                          onChange={(selectedOption) => {
                            if (inputFieldsValidation()) {
                              swal({
                                icon: "error",
                                title: "Missing Required Fields",
                                text: "Please fill out the required invoice details above before adding items.",
                              });
                              setValidated(true);
                              return;
                            }
                            handleProductChange(index, selectedOption);
                            setValidated(false);
                          }}
                          onMenuOpen={() => {
                            if (!selectedWarehouse) {
                              swal({
                                icon: "warning",
                                title: "Missing Required Information",
                                text: "Please select a warehouse before continuing.",
                              });
                              return;
                            }

                            if (productData.length === 0) {
                              const wrapper = document.createElement("div");
                              wrapper.classList.add("center-swal-text");
                              wrapper.innerHTML =
                                "No products found. Please create a product first to proceed.";
                              swal({
                                icon: "warning",
                                title: "No Product Found",
                                content: wrapper,
                              });
                              return;
                            }
                          }}
                          menuIsOpen={
                            productData.length === 0 ? false : undefined
                          }
                          placeholder={`Select Product`}
                          styles={selectCustomStyles(
                            item.productName,
                            validated,
                            "0",
                            // selectProductWidth,
                          )}
                          // isDisabled={!selectedCustomer || !selectedWarehouse}
                          menuPortalTarget={document.body}
                          menuPosition="fixed"
                          // required
                          isSearchable
                        /> */}

                        {/* ---------- REVISED START -------- } */}
                        {/* Third Product Selection (Revision) */}
                        {/* Re-use the second product selection then revise */}
                        <Select
                          options={getFilteredProductData(index).map(
                            (data) => ({
                              value: data.product_id,
                              label: data.product_name,
                            }),
                          )}
                          classNamePrefix="item-list-table-select"
                          value={item?.productName}
                          onChange={(selectedOption) => {
                            if (inputFieldsValidation()) {
                              swal({
                                icon: "error",
                                title: "Missing Required Fields",
                                text: "Please fill out the required invoice details above before adding items.",
                              });
                              setValidated(true);
                              return;
                            }
                            handleProductChange(index, selectedOption);
                            setValidated(false);
                          }}
                          onMenuOpen={() => {
                            if (!selectedWarehouse) {
                              swal({
                                icon: "warning",
                                title: "Missing Required Information",
                                text: "Please select a warehouse before continuing.",
                              });
                              return;
                            }

                            if (productData.length === 0) {
                              const wrapper = document.createElement("div");
                              wrapper.classList.add("center-swal-text");
                              wrapper.innerHTML =
                                "No products found. Please create a product first to proceed.";
                              swal({
                                icon: "warning",
                                title: "No Product Found",
                                content: wrapper,
                              });
                              return;
                            }
                          }}
                          menuIsOpen={
                            productData.length === 0 ? false : undefined
                          }
                          styles={themeSelectStyles(
                            withWrappableProductStyles(
                              selectCustomStyles(
                                item.productName?.value ?? "optional", // ← always truthy
                                validated,
                                "0",
                                selectProductWidth,
                              ),
                            ),
                          )}
                          // isDisabled={!selectedCustomer || !selectedWarehouse}
                          menuPortalTarget={document.body}
                          // menuPosition="fixed"
                          // required
                          isSearchable
                        />
                        {/* ---------- REVISED END -------- } */}
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control form-control-sm p-2"
                          value={formatToTwoDecimal(item.remaining)}
                          readOnly
                        />
                      </td>
                      {/* Old SRP Input */}
                      {/* <td> 
                    <input
                          type="text"
                          className="form-control form-control-sm p-2"
                          value={(
                            parseFloat(item.averagePrice) || 0
                          ).toLocaleString("en-US", {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2,
                          })}
                          readOnly
                        /> 
                      </td> */}
                      <td>
                        {/* Old Unit Price */}
                        {/* <div className="unit-price-wrapper">
                          <input
                            type="text"
                            className="form-control form-control-sm p-2"
                            value={item.unitPrice}
                            // required={
                            //   !!(item.productName && item.productName.value)
                            // }
                            placeholder="0"
                            onChange={(e) => {
                              handleInputChange(
                                index,
                                "unitPrice",
                                e.target.value,
                              );
                            }}
                            disabled={!item.productName}
                          />
                          {priceIndicator && (
                            <span
                              className={`price-indicator ${priceIndicator.color}`}
                            >
                              {priceIndicator.label} ({priceIndicator.symbol}
                              {(
                                parseFloat(priceIndicator.srp) || 0
                              ).toLocaleString("en-US", {
                                minimumFractionDigits: 2,
                                maximumFractionDigits: 2,
                              })}
                              )
                            </span>
                          )}
                        </div> */}

                        {/* New Unit Price and Supplier Price */}
                        <div className="unit-price-wrapper">
                          <input
                            type="text"
                            className="form-control form-control-sm p-2"
                            value={
                              unitPriceInputs[index] !== undefined
                                ? unitPriceInputs[index]
                                : item?.unitPrice
                            }
                            placeholder="0"
                            onInput={(e) => {
                              if (
                                e.target.value.startsWith("0") &&
                                e.target.value.length === 2 &&
                                e.target.value[1] !== "."
                              ) {
                                e.target.value = e.target.value.slice(1);
                              }
                              e.target.value = e.target.value.replace(
                                /[^0-9.]/g,
                                "",
                              );
                              const val = e.target.value;
                              const dotIndex = val.indexOf(".");
                              if (
                                dotIndex !== -1 &&
                                val.length - dotIndex > 5
                              ) {
                                e.target.value = val.slice(0, dotIndex + 5);
                              }
                            }}
                            onChange={(e) => {
                              setUnitPriceInputs((prev) => ({
                                ...prev,
                                [index]: e.target.value,
                              }));
                            }}
                            onBlur={(e) => {
                              const raw = e.target.value.replace(
                                /[^0-9.]/g,
                                "",
                              );
                              handleInputChange(index, "unitPrice", raw);
                              setUnitPriceInputs((prev) => {
                                const next = { ...prev };
                                delete next[index];
                                return next;
                              });
                            }}
                            disabled={!item?.productName}
                          />
                          {priceIndicator && (
                            <span
                              className={`price-indicator ${priceIndicator.color}`}
                            >
                              {priceIndicator.label} ({priceIndicator.symbol}
                              {formatToTwoDecimal(priceIndicator.srp)})
                            </span>
                          )}
                        </div>
                      </td>
                      <td>
                        <div className="input-group"></div>
                        <Form.Control
                          type="text"
                          className="form-control form-control-sm p-2"
                          placeholder="Input QTY"
                          value={item?.quantity}
                          onChange={(e) => {
                            handleInputChange(
                              index,
                              "quantity",
                              e.target.value,
                            );
                          }}
                          // required={
                          //   !!(item.productName && item.productName.value)
                          // }
                          disabled={!item?.productName}
                        />
                      </td>
                      <td>
                        {/* Form Moist */}
                        <div className="input-group">
                          <Form.Control
                            type="text"
                            className="form-control form-control-sm p-2"
                            placeholder="Input Moisture"
                            value={item?.moisture}
                            onChange={(e) => {
                              handleInputChange(
                                index,
                                "moisture",
                                e.target.value,
                              );
                            }}
                            // required={
                            //   !!(item.productName && item.productName.value)
                            // }
                            disabled={!item?.productName}
                          />
                          <span class="input-group-text" id="basic-addon1">
                            %
                          </span>
                        </div>
                      </td>
                      <td>
                        <Form.Control
                          type="text"
                          className="form-control form-control-sm p-2"
                          placeholder="Input Net Qty"
                          value={item?.netWeight}
                          onChange={(e) =>
                            handleInputChange(
                              index,
                              "netWeight",
                              e.target.value,
                            )
                          }
                          // required={
                          //   !!(item.productName && item.productName.value)
                          // }
                          disabled={!item?.productName}
                        />
                      </td>
                      <td className="text-center">
                        <div className="input-group mb-2">
                          <Form.Control
                            type="text"
                            className="form-control-sm p-2"
                            id="inlineFormInputGroup"
                            placeholder={
                              item.discountType === "percentage"
                                ? "Discount (%)"
                                : `Discount (${currencySymbol})`
                            }
                            value={item?.discount}
                            onChange={(e) =>
                              handleInputChange(
                                index,
                                "discount",
                                e.target.value,
                              )
                            }
                            // required={
                            //   !!(item.productName && item.productName.value)
                            // }
                            disabled={!item?.productName}
                          />
                          <div className="input-group-prepend">
                            <button
                              className="input-group-text bg-white custom-discount-btn"
                              onClick={() => handleDiscountButton(index)}
                              type="button"
                              disabled={!item?.productName}
                            >
                              {item?.discountType === "percentage"
                                ? "%"
                                : currencySymbol}
                            </button>
                          </div>
                        </div>
                      </td>
                      <td>
                        <input
                          type="text"
                          className="form-control form-control-sm p-2"
                          value={formatToTwoDecimal(item.subtotal)}
                          readOnly
                          placeholder="0.00"
                        />
                      </td>
                      <td className="text-center">
                        {index !== 0 && index < items?.length && (
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => removeItem(index)}
                            type="button"
                          >
                            <i className="fa-solid fa-trash-can"></i>
                          </button>
                        )}
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
          <div className="w-100 d-flex justify-content-end mt-2">
            <button
              className="btn btn-primary btn-sm"
              type="button"
              onClick={addNewItem}
            >
              New Item
            </button>
          </div>
        </div>
        <div className="row mx-auto p-2 mt-4 mb-4">
          <div className="col-sm"></div>
          <div className="col-sm border-end">
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Qty</span>
              <span className="text-secondary">
                {formatToTwoDecimal(totalQuantity)}
              </span>
            </div>
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Moisture</span>
              <span className="text-danger">{totalMoisture}</span>
            </div>
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Net Qty</span>
              <span className="text-danger">
                {formatToTwoDecimal(totalNetWeight)}
              </span>
            </div>
          </div>
          <div className="col-sm">
            {/* 1. Total Qty Amount */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Qty Amount</span>
              <span className="text-secondary">
                {currencySymbol}
                {formatToTwoDecimal(totalWeightedAmount)}
              </span>
            </div>

            {/* 2. Total Amount of Moisture */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Amount of Moisture</span>
              <span className="text-danger">
                {currencySymbol}
                {formatToTwoDecimal(totalMoistureAmount)}
              </span>
            </div>

            {/* 3. Total Net Qty Amount */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Total Net Qty Amount</span>
              <span className="text-danger">
                {currencySymbol}
                {formatToTwoDecimal(totalNetWeightAmount)}
              </span>
            </div>

            <hr className="flex-grow-1 mx-3" />

            {/* 4. Subtotal = Net Qty Amount - Item Discounts */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Subtotal</span>
              <span className="text-secondary">
                {currencySymbol}
                {formatToTwoDecimal(totalNetWeightAmount - totalItemDiscount)}
              </span>
            </div>

            {/* 5. Discount (₱) — transaction discount */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Discount (₱)</span>
              <span
                className="text-primary"
                onClick={handleShowTransactionDiscount}
                style={{ cursor: "pointer" }}
              >
                {displayDiscount > 0 ? (
                  <>
                    {modalDiscountType === "percentage"
                      ? `${formatToTwoDecimal(displayDiscount)}%`
                      : `${currencySymbol}${formatToTwoDecimal(displayDiscount)}`}
                    <span
                      className="ms-2"
                      style={{
                        color: "red",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={handleRemoveDiscount}
                    >
                      Remove
                    </span>
                  </>
                ) : (
                  "Add"
                )}
              </span>
            </div>

            {/* 6. Gross Amount = preVatBase */}
            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>Gross Amount</span>
              <span className="text-secondary">
                {currencySymbol}
                {formatToTwoDecimal(preVatBase)}
              </span>
            </div>

            <hr className="flex-grow-1 mx-3" />

            {/* 7. VAT — green, basis is Gross Amount */}
            {selectedCustomer && (
              <div className="w-100 d-flex flex-row justify-content-between p-2">
                <span style={{ color: "#198754" }}>
                  {!isSpecialTax && vatPercent > 0
                    ? `VAT (${vatPercent}%)`
                    : "Non-VAT"}
                </span>
                <span style={{ color: "#198754" }}>
                  {currencySymbol}
                  {!isSpecialTax && vatPercent > 0
                    ? formatToTwoDecimal((vatPercent / 100) * preVatBase)
                    : "0.00"}
                </span>
              </div>
            )}

            {/* 8. Withholding Tax — basis is Gross Amount */}
            {selectedCustomer && selectedTaxId && selectedTaxRate > 0 && (
              <div className="w-100 d-flex flex-row justify-content-between p-2">
                <span style={isSpecialTax ? { opacity: 0.5 } : {}}>
                  Withholding Tax ({selectedTaxRate}%)
                </span>
                <span
                  className="text-danger"
                  style={isSpecialTax ? { opacity: 0.5 } : {}}
                >
                  {currencySymbol}
                  {formatToTwoDecimal(
                    !isSpecialTax ? (selectedTaxRate / 100) * preVatBase : 0,
                  )}
                </span>
              </div>
            )}

            {selectedCustomer && (
              <div className="w-100 d-flex flex-row justify-content-between p-2 align-items-center">
                <Form.Check
                  type="checkbox"
                  id="special-tax-computation"
                  label={
                    <span
                      title={`E = Gross Amount * 1.12\nL = Gross Amount * 0.12\nI = E * 0.01\nTax (Special Computation) = L - I`}
                      style={{ cursor: "pointer", userSelect: "none" }}
                    >
                      Tax{" "}
                      <small className="text-muted">
                        (Special Computation)
                      </small>
                    </span>
                  }
                  className="mb-0"
                  style={{ cursor: "pointer" }}
                  checked={isSpecialTax}
                  onChange={handleSpecialTax}
                />
                {isSpecialTax && (
                  <span className="text-secondary text-success">
                    {currencySymbol}
                    {formatToTwoDecimal(preVatBase * 0.1088)}
                  </span>
                )}
              </div>
            )}

            {selectedCustomer && <hr className="flex-grow-1 mx-3" />}

            {/* 9. Weighing Fee (Non-Taxable) */}
            {/* <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>
                Weighing Fee <small className="text-muted">(Non-Taxable)</small>
              </span>
              <span
                className="text-primary"
                onClick={handleShowWeighingFee}
                style={{ cursor: "pointer" }}
              >
                {displayWeighingFee > 0 ? (
                  <>
                    {currencySymbol}
                    {formatToTwoDecimal(displayWeighingFee)}
                    <span
                      className="ms-2"
                      style={{
                        color: "red",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={handleRemoveWeighingFee}
                    >
                      Remove
                    </span>
                  </>
                ) : (
                  "Add"
                )}
              </span>
            </div> */}

            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>
                Weighing Fee <small className="text-muted">(Non-Taxable)</small>
              </span>
              <span className="text-danger">
                <NumberInDecimals
                  className="form-control form-control-sm py-2 text-danger text-end fs-6 input-payable-form"
                  placeholder="0.00"
                  decimals={2}
                  value={inputWeighingFee}
                  onChange={handleWeighingFeeChange}
                  style={{ paddingRight: validated ? "2rem" : "0.5rem" }}
                />
              </span>
            </div>

            {/* 10. Other Fee (Non-Taxable) */}
            {/* <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>
                Other Fee <small className="text-muted">(Non-Taxable)</small>
              </span>
              <span
                className="text-primary"
                onClick={handleShowOtherFee}
                style={{ cursor: "pointer" }}
              >
                {displayOtherFee > 0 ? (
                  <>
                    {currencySymbol}
                    {formatToTwoDecimal(displayOtherFee)}
                    <span
                      className="ms-2"
                      style={{
                        color: "red",
                        textDecoration: "underline",
                        cursor: "pointer",
                      }}
                      onClick={handleRemoveOtherFee}
                    >
                      Remove
                    </span>
                  </>
                ) : (
                  "Add"
                )}
              </span>
            </div> */}

            {(() => {
              const start = otherFeePage * OTHER_FEE_PAGE_SIZE;
              const pageSlice = otherFees.slice(
                start,
                start + OTHER_FEE_PAGE_SIZE,
              );
              const totalPages = Math.ceil(
                otherFees.length / OTHER_FEE_PAGE_SIZE,
              );
              return (
                <>
                  {pageSlice.map((fee, pageIndex) => {
                    const index = start + pageIndex;
                    return (
                      <div
                        key={index}
                        className="w-100 d-flex flex-row justify-content-between p-2"
                      >
                        <Form.Control
                          type="text"
                          size="sm"
                          placeholder="Fee Name"
                          value={fee.feeName}
                          onChange={(e) =>
                            handleFeeChange(index, "feeName", e.target.value)
                          }
                        />
                        <NumberInDecimals
                          className="form-control form-control-sm text-danger"
                          placeholder="0.00"
                          decimals={2}
                          value={fee.feeAmount}
                          onChange={(val) =>
                            handleFeeChange(index, "feeAmount", val)
                          }
                        />
                        <button
                          type="button"
                          className="btn btn-sm btn-outline-danger"
                          onClick={() => removeFee(index)}
                        >
                          X
                        </button>
                      </div>
                    );
                  })}
                  {totalPages > 1 && (
                    <div className="w-100 d-flex justify-content-between align-items-center px-2 pb-1">
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        disabled={otherFeePage === 0}
                        onClick={() => setOtherFeePage((p) => p - 1)}
                      >
                        ‹ Prev
                      </button>
                      <small className="text-muted">
                        {otherFeePage + 1} / {totalPages}
                      </small>
                      <button
                        type="button"
                        className="btn btn-sm btn-outline-secondary"
                        disabled={otherFeePage >= totalPages - 1}
                        onClick={() => setOtherFeePage((p) => p + 1)}
                      >
                        Next ›
                      </button>
                    </div>
                  )}
                </>
              );
            })()}

            <div className="w-100 d-flex flex-row justify-content-between p-2">
              <span>
                Other Fee <small className="text-muted">(Non-Taxable)</small>
              </span>
              <button
                type="button"
                onClick={addNewFee}
                className="border-0 text-primary bg-white p-0"
              >
                Add
              </button>
            </div>

            {/* 11. Total Amount */}
            <div className="w-100 d-flex flex-row justify-content-between p-3 mt-3 total-amount-container align-items-center rounded">
              <span className="text-white">Total Amount</span>
              <span className="text-white">
                {currencySymbol}
                {formatToTwoDecimal(totalAmount)}
              </span>
            </div>
          </div>
        </div>

        <div className="container-fluid mt-5">
          <div className="row">
            <div className="col-sm mb-2"></div>
            <div className="col-sm"></div>
            <div className="col-sm"></div>
            <div className="col-sm">
              <div className="row">
                <div className="col-sm mb-2">
                  <button
                    className="btn btn-outline-secondary w-100"
                    type="button"
                    onClick={CancelInvoice}
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-sm">
                  <button
                    className="btn btn-primary w-100 d-inline-flex align-items-center justify-content-center gap-2"
                    type="submit"
                    disabled={isSaving}
                  >
                    {isSaving ? (
                      <>
                        <span
                          className="spinner-border spinner-border-sm"
                          role="status"
                          aria-hidden="true"
                        />
                        Saving...
                      </>
                    ) : (
                      "Save"
                    )}
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </Form>

      {/* Transaction Discount Modal  */}
      <Modal
        show={transactionDiscountModal}
        onHide={handleCloseTransactionDiscount}
        size="md"
      >
        <Form>
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title>Discount</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex fs-6">
              <p>
                The discounts will be applied to this transaction automatically
              </p>
            </div>
            <div className="input-group mb-2">
              <Form.Control
                type="text"
                className="form-control-sm p-2"
                id="inlineFormInputGroup"
                value={inputDiscount}
                min={0}
                onChange={handleTransactionDiscount}
                placeholder={
                  modalDiscountType === "percentage"
                    ? "Discount (%)"
                    : `Discount (${currencySymbol})`
                }
              />
              <div className="input-group-prepend">
                <div
                  className="input-group-text bg-white custom-discount-btn"
                  onClick={handleDiscountIcon}
                >
                  {modalDiscountType === "percentage" ? "%" : currencySymbol}
                </div>
              </div>
            </div>
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <Button
              variant="outline-secondary"
              onClick={handleCloseTransactionDiscount}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddDiscount}>
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Weighing Fee Modal */}
      <Modal show={weighingFeeModal} onHide={handleCloseWeighingFee} size="md">
        <Form>
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title>Weighing Fee (Non-Taxable)</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="fs-6">
              This fee is non-taxable and will not affect VAT or Withholding Tax
              calculations.
            </p>
            <Form.Control
              type="text"
              className="form-control-sm p-2"
              value={inputWeighingFee}
              placeholder={`Amount (${currencySymbol})`}
              onChange={(e) => {
                let v = e.target.value.replace(/[^0-9.]/g, "");
                if ((v.match(/\./g) || []).length > 1) return;
                setInputWeighingFee(v);
              }}
            />
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <Button
              variant="outline-secondary"
              onClick={handleCloseWeighingFee}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddWeighingFee}>
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Other Fee Modal */}
      <Modal show={otherFeeModal} onHide={handleCloseOtherFee} size="md">
        <Form>
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title>Other Fee (Non-Taxable)</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p className="fs-6">
              This fee is non-taxable and will not affect VAT or Withholding Tax
              calculations.
            </p>
            <Form.Control
              type="text"
              className="form-control-sm p-2"
              value={inputOtherFee}
              placeholder={`Amount (${currencySymbol})`}
              onChange={(e) => {
                let v = e.target.value.replace(/[^0-9.]/g, "");
                if ((v.match(/\./g) || []).length > 1) return;
                setInputOtherFee(v);
              }}
            />
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <Button variant="outline-secondary" onClick={handleCloseOtherFee}>
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddOtherFee}>
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>

      {/* Shipping Fee modal  */}
      <Modal show={shippingFeeModal} onHide={handleCloseShippingFee} size="md">
        <Form>
          <Modal.Header closeButton style={{ border: "none" }}>
            <Modal.Title>Shipping Fee</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="d-flex fs-6">
              <p>
                Shipping fees are calculated based on the total of your order
                and your location
              </p>
            </div>
            <div className="input-group mb-2">
              <Form.Control
                type="text"
                className="form-control-sm p-2"
                id="inlineFormInputGroup"
                placeholder="Amount 0.00"
                value={inputShippingFee}
                onChange={(e) => {
                  const value = e.target.value;
                  if (value == ".") {
                    setInputShippingFee((prev) => prev + ".");
                  }
                  let inputValue = value.replace(/[^0-9.]/g, "");
                  if (inputValue) {
                    inputValue = inputValue.replace(
                      /\B(?=(\d{3})+(?!\d))/g,
                      ",",
                    );
                  }

                  const cleanedValue = inputValue.replace(/^0+,|^0+/, ""); // Remove leading zeros and comma
                  setInputShippingFee(cleanedValue);
                }}
                min={0}
              />
            </div>
          </Modal.Body>
          <Modal.Footer style={{ border: "none" }}>
            <Button
              variant="outline-secondary"
              onClick={handleCloseShippingFee}
            >
              Cancel
            </Button>
            <Button variant="primary" onClick={handleAddShippingFee}>
              Add
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </div>
  );
};

export default Create_invoice;
